import { useEffect, useState } from 'react';
import api from '../../api';

// Loads inverter + gateway hardware/firmware metadata for a single gateway device.
// Returns null metadata (not an error) when the gateway has no metadata recorded yet
// (the backend answers 404 in that case), so the page can render a graceful empty state.
const useHttpGetGatewayMetadata = deviceId => {
    const [metadata, setMetadata] = useState(null);
    const [isReady, setIsReady] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (!deviceId) {
            return undefined;
        }

        let active = true;
        setIsReady(false);
        setError(false);

        const load = async () => {
            try {
                const res = await api.get_device_gateway_metadata(deviceId);
                if (active) {
                    setMetadata(res?.data ?? null);
                }
            } catch (err) {
                if (active) {
                    setMetadata(null);
                    // A 404 just means "no metadata yet" — not a hard error for the page.
                    setError(err?.response?.status ? err.response.status !== 404 : true);
                }
            } finally {
                if (active) {
                    setIsReady(true);
                }
            }
        };

        load();
        return () => {
            active = false;
        };
    }, [deviceId]);

    return { metadata, isReady, error };
};

export default useHttpGetGatewayMetadata;
